export const MESSAGE_ADD_LECTURE_SUCCESS = '강의를 추가했습니다.';
export const MESSAGE_REMOVE_LECTURE_SUCCESS = '강의를 삭제했습니다.';
export const MESSAGE_ENROLL_LECTURE_SUCCESS = '수강 신청되었습니다.';
export const MESSAGE_UNAUTHORIZED_ACCESS = '접근 권한이 없습니다.';
export const MESSAGE_CANNNOT_ENROLL_LECTURE_ERROR = '수강 신청할 수 없는 강의입니다.';



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture-message.ts